export const isMobile = width => width <= 480
export const isTablet = width => width < 1024 && width > 480
export const isDesktop = width => width >= 1024
export const isTabletOrMobile = width => width < 1025
